export const selfDescriptionsEn = {
  selfDescriptions: {
    'Motivator': 'Motivator',
    'Team Player': 'Team Player',
    'Analysis': 'Analysis',
    'Solo Player': 'Solo Player'
  }
};